import growthIcon from "../../icons/growth.svg";
import cooperationIcon from "../../icons/cooperation.svg";
import innovationIcon from "../../icons/innovation.svg";
import securityIcon from "../../icons/security.svg";
import opennessIcon from "../../icons/openness.svg";
import { useInternationalizedItems } from "../../custom-hooks/useInternationalizedItems";

const iconMap: Record<string, string> = {
    growth: growthIcon,
    cooperation: cooperationIcon,
    innovation: innovationIcon,
    security: securityIcon,
    openness: opennessIcon,
};

interface RightPanelItems {
    title: string;
    subtitle: string;
    icon: string;
}

export default function MissionRightPanel() {
    const items = useInternationalizedItems<RightPanelItems[]>({
        key: "home.missionPoints",
    });

    return (
        <div className="w-full xl:w-[630px] flex flex-col gap-4 xl:gap-3">
            {items.map((item, index) => (
                <div
                    key={index}
                    className="w-[360px] md:w-full h-[95px] md:h-[111px] lap:h-[120px] xl:h-[118px] lg:w-[630px] lg:h-[111px] p-3 lg:p-7 border-2 border-white rounded-md flex items-center gap-4 lg:gap-5 text-text-400"
                >
                    <div className="w-[42px] h-[42px] flex items-center justify-center rounded">
                        <img src={iconMap[item.icon]} alt={item.title} className="w-[26px] h-[28px]" />
                    </div>
                    <div className="w-[230px] md:w-full lg:w-[336px] flex flex-col gap-1.5">
                        <h4 className="text-lg lg:text-xl font-medium">{item.title}</h4>
                        <p className="text-base lg:text-lg font-normal">{item.subtitle}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
